export class CharValueObject {

    constructor(private name: string, private value: string) {
        this.name = name;
        this.value = value;
    }

    public getName() {
        return this.name;
    }

    public getValue() {
        return this.value;
    }
}